
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";

  import DropdownFilter from "@/components/filters/DropdownFilter.vue";

  import DropdownOption from "@/entities/DropdownOption";
  import { customRequestStatusNames } from "@/entities/CustomRequestStatus";

  @Component({
    components: {
      DropdownFilter,
    }
  })
  export default class CustomRequestStatusMultiselect extends Vue {
    @Prop({ type: Array, required: true }) readonly value!: string[];
    @Prop({ type: Boolean, default: true }) readonly multiple!: boolean;

    chosenStatuses: DropdownOption[] = [];
    get statusOptions(): DropdownOption[] {
      return Object
        .entries(customRequestStatusNames)
        .map(([id, name]) => ({
          id,
          name
        }));
    }

    @Watch('value', {immediate: true})
    updateChosenStatus() {
        this.chosenStatuses =  Object
          .entries(customRequestStatusNames)
          .filter(([id]) => this.value.includes(id))
          .map(([id, name]) => ({id, name}));
    }

    get options(): DropdownOption[] {
      if (!this.multiple) {
        return this.statusOptions;
      }
      return this.statusOptions.filter(option => {
        return !this.value.includes(option.id);
      })
    }

    handleInput(chosenStatuses: DropdownOption[]): void {
      this.chosenStatuses = chosenStatuses;
      this.$emit("input", chosenStatuses.map(option => (option.id)));
    }
  }

